/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-1",
    "aws_dynamodb_all_tables_region": "us-west-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "twitdomains-dev",
            "region": "us-west-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-west-1:96040513-3371-45af-944b-de48ae493fd3",
    "aws_cognito_region": "us-west-1",
    "aws_user_pools_id": "us-west-1_JplYuIA5J",
    "aws_user_pools_web_client_id": "3j7cp9guidnr3f7qsr08ergmqr",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "apiTwitterDomains",
            "endpoint": "https://gckzy5jch5.execute-api.us-west-1.amazonaws.com/dev",
            "region": "us-west-1"
        }
    ]
};


export default awsmobile;
